import { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../data/translations';

const LangContext = createContext();

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('sttora-lang') || 'es');

  const t = (key) => translations[lang]?.[key] ?? translations['es'][key] ?? key;

  const changeLang = (newLang) => {
    setLang(newLang);
    localStorage.setItem('sttora-lang', newLang);
    document.documentElement.lang = newLang;
  };

  useEffect(() => { document.documentElement.lang = lang; }, [lang]);

  return (
    <LangContext.Provider value={{ lang, changeLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
